import type { W_Job_FindAllJobsForJobFilter_VM, W_Job_FindAllJobsForJobFilter_VM_Single } from 'ab-api/web/job/findAllJobsForJobFilter';

export class JobFilterItem {
	id: number;
	label: string;
	jobCode: string;
	title: Nullable<string>;
	customerCompany: Nullable<string>;
	isInternal: boolean;

	constructor(job: W_Job_FindAllJobsForJobFilter_VM_Single) {
		this.id = job.id;
		this.jobCode = job.jobCode;
		this.title = job.title;
		this.isInternal = job.isInternal;
		this.customerCompany = job.customerCompany;
		const customerCompany = !!job.customerCompany ? ` ${job.customerCompany}` : '';
		const title = !!job.title ? ` | ${job.title}` : '';
		this.label = `${job.jobCode}${customerCompany}${title}`;
	}

	private static _constructorMap = (job: W_Job_FindAllJobsForJobFilter_VM_Single) => new JobFilterItem(job);

	static bulkConstructor = (jobs: W_Job_FindAllJobsForJobFilter_VM) => jobs.map((job) => { return JobFilterItem._constructorMap(job); });

}
